import { Action, createAction } from '@ngrx/store';

export const SideNavOpen = createAction('[UI] Side Nav Open');
export const SideNavClose = createAction('[UI] Side Nav Close');
export const SideNavToggle = createAction('[UI] Side Nav Toggle');
